import { toQueryString } from '@utils/requests';

import { Company } from 'types/companies';
import { ITODO } from 'types/todo';

import { request, unhandledRequest } from '../request';

type UpdateSocialData = {
  title?: string;
  description?: string;
  image?: File;
};

export function updateCompanySocialData(data: UpdateSocialData) {
  const formData = new FormData();
  if (data.image) {
    formData.append('image', data.image);
  }
  if (data.description) {
    formData.set('description', data.description);
  }
  if (data.title) {
    formData.set('title', data.title);
  }
  return unhandledRequest.post({
    url: '/company/social/',
    data: formData,
  });
}

type UpdateCareerImageProps = { logo?: File; banner?: File };

export const updateCareerImage = ({ logo, banner }: UpdateCareerImageProps) => {
  const data = new FormData();
  if (logo) {
    data.append('logo', logo);
  }
  if (banner) {
    data.append('banner', banner);
  }
  return unhandledRequest.patch({ url: `/company/images/`, data });
};

export function loadAzureADSettings(email: string) {
  return request.get({
    url: '/azure/' + toQueryString({ email }),
  });
}

export function load() {
  return request.get({
    url: '/company/',
  });
}

export async function unhandledLoad() {
  const response = await unhandledRequest.get<Company>({
    url: '/company/',
  });
  return response.data;
}

export type TemplateType = {
  id: string;
  title: string;
  contentHtml: string;
  templateType: string;
};

export async function loadUnhandledTemplates() {
  const response = await unhandledRequest.get<TemplateType[]>({
    url: '/templates/',
  });
  return response.data;
}

export async function loadTemplates() {
  return await request.get({
    url: '/templates/',
  });
}

export function updateTemplate(templateId: number, data: ITODO) {
  return request.patch({
    url: `/templates/${templateId}/`,
    data,
  });
}

export function createTemplate(data: ITODO) {
  return request.post({
    url: '/templates/',
    data,
  });
}

export function deleteTemplate(templateId: number) {
  return request.delete({
    url: `/templates/${templateId}/`,
  });
}

type UpdateInfoData = Partial<
  Pick<
    Company,
    | 'companyName'
    | 'gaTracker'
    | 'privacyPolicyUrl'
    | 'senderName'
    | 'url'
    | 'defaultLanguage'
    | 'languages'
    | 'logoHeight'
    | 'isDeadlineRequired'
  >
>;

export function updateCompany(data: UpdateInfoData) {
  return unhandledRequest.patch({
    url: '/company/',
    data,
  });
}

export type IntegrationSettings = {
  connected: string[];
};

export async function loadIntegrationsSettings() {
  const response = await unhandledRequest.get<IntegrationSettings>({
    url: `/company/settings/integrations/`,
  });

  return response.data;
}

export function patchIntegration(url: string) {
  return request.patch({
    url,
  });
}
